export const SevenAcre3 = require('./7acre3.jpg');
export const BlueRedPipeWrench = require('./blue-red-pipewrench.jpg');
export const Bg_jpg = require('./kontact-link-bg.jpg');
export const Bg_png = require('./kontact-link-bg.png');
export const FullLogo1_png = require('./logo.png');
export const FullLogo1_jpg = require('./Logo.jpg');
export const LogoWords1_png = require('./logo-1-words.png');
export const LogoHelmet1_jpg = require('./logo-1-cropped.jpg');
export const FullLogo2_jpg = require('./Spartan-Logo.jpg');
export const FullLogo2_png = require('./Spartan-Logo.png');



